var map = {
	"./ts03.jpg": 8430,
	"./ts1.jpg": 8635,
	"./ts2.jpg": 9385,
	"./ts4.jpg": 1545,
	"assets/collections/editorials/tearsheets/ts03.jpg": 8430,
	"assets/collections/editorials/tearsheets/ts1.jpg": 8635,
	"assets/collections/editorials/tearsheets/ts2.jpg": 9385,
	"assets/collections/editorials/tearsheets/ts4.jpg": 1545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5463;